import React from 'react';
import { Form, Input, Button,Spin,Select, message,DatePicker,Result,Popover,Switch,Popconfirm,Card,Divider,Table } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined,DeleteOutlined,PlusCircleFilled,PlusCircleOutlined,PrinterOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import ReactToPrint from "react-to-print";
import CurrencyFormat from "react-currency-format";

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

var token= ''
var sacco= ''
var username=''


const { Option } = Select;

class LoanInterestWaivingForm_MultiCycles extends React.Component {

  state = {
    other_email:'' ,  
    datarequested:true,
    schedules_towaive:[],
    loanschedule:[],
    waiver_date:'',
    datasubmittedsuccessfully:false,
    message:'',
    waive_reason:''
  }


  componentDidMount(){  
    this.compoenent_loaded()
   
  }


  compoenent_loaded=()=>{
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }

   if(localStorage.getItem("sacco")){
    username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   }else{
    username=''

  }
    

    var loanissueID=this.props.loanobj.id

    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }



     //getting the invoice total payment now
     axios.get(`${serverconfig.backendserverurl}/api/loanschedules/?loanissue=${loanissueID}`)
     .then(res => { 


       this.setState({loanschedule:res.data})
       this.setState({datarequested:false})
       this.setState({datasubmittedsuccessfully:false})

     })



  }



  //submit button pressed
  handleFormSubmit=(event) =>{
    if (this.state.waiver_date===""){
      message.error("Please select date")
    }else if (this.state.schedules_towaive.length<=0){
      message.error("Please select cycles")
    }else if (this.calCulateWaiverTotal()<=0){
      message.error("Waiving Amount is less")
    }
    else{

    //make qery now
    let form_data = new FormData();
    form_data.append('waiver_date', this.state.waiver_date);
    form_data.append('waive_reason', this.state.waive_reason);
    form_data.append('user',username );
    form_data.append('sacco',sacco);
    form_data.append('total_amount', this.calCulateWaiverTotal());
    form_data.append('schedules_towaive', JSON.stringify(this.state.schedules_towaive) );
    form_data.append('loan_id', this.props.loanobj.id);

    this.setState({datarequested:true})

    axios.post(serverconfig.backendserverurl+'/customqueries/confirmloan_interestwaiving_multiplecycles', form_data,{
      headers: {
        'content-type': 'multipart/form-data'
      } })
    .then(res => {
      this.setState({datarequested:false})
      this.setState({message:res.data.message})
      this.setState({datasubmittedsuccessfully:true})


      //do reset here
      this.setState({waive_reason:''})
      this.setState({schedules_towaive:[]})



    })
    .catch(error => console.log(error))
    }


  }


   isValidEmail=(email)=> {
    // Regular expression pattern for validating email addresses
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }


    //check if account already added
    isemail_added = (account, account_list) => {
      return account_list.some((item) => item === account);
    };

    //chekc if invoice exists
    isScheduleAdded=(account, inv_list) => {
      return inv_list.some((item) => item.key === account);
    };


    calCulateWaiverTotal=()=>{
      var total=0
      this.state.schedules_towaive.map((item)=>{
        total+=Number(item.Amount)
      })

      return total;

    }



  
  render(){

    const columns = [
      {
        title: "Add To List",
        dataIndex: "repayment_number",
        key: "id",
        render: (text,record) =>
        <p>
          <PlusCircleFilled 
          style={{color:this.isScheduleAdded(record.id,this.state.schedules_towaive)===true?"green":'grey',
          fontSize: '30px'
          ,margin:2}}
          
          onClick={()=>{
            if (this.isScheduleAdded(record.id,this.state.schedules_towaive)===true){
             
              this.setState({ schedules_towaive:  [...this.state.schedules_towaive.filter(todo => todo.key
                !==record.id)]});
            
              console.log("Invoice removed")
          
            }else{
              this.setState({schedules_towaive: [...this.state.schedules_towaive,{"key":record.id,"Amount":record.interest}  ]});
              console.log("Invoice added")
            }


          }}
          
          
          />
        </p>
      },
      
      {
        title: "Date",
        dataIndex: "date",
        key: "id",
      },
     
      {
        title: "Interest Pay",
        dataIndex: "interest",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },

      {
        title: "Principle Pay",
        dataIndex: "principle",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },


     

      {
        title: "Total Pay",
        dataIndex: "total",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },




    ];



    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{


      if(this.state.datasubmittedsuccessfully===true){
        return (
        <Card>
        <Result
        status="success"
        title="Successful waiving of interest"
        subTitle={this.state.message}
        extra={[
          <Button  type='primary' 
            onClick={()=>{
            this.setState({datasubmittedsuccessfully:false})
            this.compoenent_loaded()
          }}>Finish</Button>,
        ]}
        />
        </Card>
        )
      }else{

      return (
        <div>
          <Card>

         <h4>Select Cycle whose interest to Waive</h4>

         {
          this.state.loanschedule.length>0?
          <Table
          columns={columns}
          pagination={{ showQuickJumper: true, showSizeChanger: true }}
          dataSource={this.state.loanschedule}
          scroll={{ x: 1000 }}
          bordered
          size='small'
          />
        :
        null
        }

         <Divider></Divider>

         <FormItem label={"Select date"}>
              <DatePicker 
              onChange={(date, dateString)=>{this.setState({ waiver_date: dateString})}} 
              format={dateFormat} 
              />
        </FormItem>


        <FormItem label="Reason/details">
           <TextArea
               placeholder="Waiving Reason"
               autoSize={{ minRows: 2, maxRows: 8 }}
               value={this.state.waive_reason}
               onChange={(val)=>{this.setState({waive_reason:val.target.value})}}
             />
        </FormItem>

        <h4>Total to waive:
          <CurrencyFormat
            value={this.calCulateWaiverTotal()}
            displayType={"text"}
            thousandSeparator={true}
          />
         </h4>


        <Button
        type="primary" 
        htmlType='button'
        onClick={(event) => this.handleFormSubmit(event)}
        
        >Waive interest
        </Button>

       </Card>
        </div>
      );

    }


    }

  }

}


export default LoanInterestWaivingForm_MultiCycles;



